module.exports = __webpack_public_path__ + "static/media/videoLibraryLine.52eb468e.svg";